<template>
  <div class="notification_dialog_content" ref="notificationDialog">
    <template>
      <h2>小时超标次数表</h2>
      <el-date-picker
        v-model="oneDay"
        type="date"
        size="mini"
        value-format="yyyy-MM-dd"
        @change="dayChange"
        :clearable="false"
      >
      </el-date-picker>
      <chart :options="hourChartOption" autoresize/>
    </template>
    <div class="chart-line">
      <h2>日超标次数表</h2>
      <el-date-picker
        v-model="peorid"
        type="daterange"
        size="mini"
        value-format="yyyy-MM-dd"
        @change="monthChange"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        :clearable="false"
      >
      </el-date-picker>
      <e-charts :options="lineData" autoresize />
    </div>
  </div>
</template>

<script>
import "v-charts/lib/style.css";
import ECharts from "vue-echarts";
import "echarts/lib/chart/line";
import "echarts/lib/chart/bar";
import "echarts/lib/component/tooltip";
import "echarts/lib/component/markLine";
import "echarts/lib/component/legend";

export default {
  props: ["localeId", "owner"],
  components: {
    chart: ECharts,
    ECharts
  },
  data() {
    return {
      oneDay: "",
      peorid: [],
      hourChartOption: {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        grid: {
          show: true,
          top: 50,
          left: 10,
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: [],
          axisLabel: {
            interval: 0
          }
        },
        yAxis: {
          type: 'value',
          name: '次数'
        },
        series: [{
          name: '次数',
          type: 'bar',
          data: [],
          itemStyle: {
            normal: {
              color: '#00A1FF'
            }
          }
        }]
      },
      lineData: {
        tooltip: {
          trigger: "axis"
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true
        },
        xAxis: {
          type: "category",
          data: [],
          boundaryGap: false,
          axisLabel: {
            interval: 1,
            rotate: 45
          }
        },
        yAxis: {
          type: "value",
          name: "次数"
        },
        series: [
          {
            name: "次数",
            type: "line",
            data: [],
            itemStyle: {
              normal: {
                color: "#00A1FF",
                lineStyle: {
                  type: "solid",
                  color: "#00A1FF"
                }
              }
            }
          }
        ]
      }
    };
  },
  mounted() {
    const last1day = this.getNextDate(-1);
    const last30day = this.getNextDate(-30);
    this.oneDay = last1day;
    this.peorid = [last30day, last1day];
    this.getHoursDatas(this.localeId, this.owner, last1day);
    this.getMonthData(this.localeId, this.owner, last30day, last1day);
  },
  watch: {
    showData: v => {
      // console.log(v);
    }
  },
  methods: {
    setDefault() {
      this.hourChartOption.xAxis.data = []
      this.hourChartOption.series[0].data = []
      this.lineData.xAxis.data = []
      this.lineData.series[0].data = []
    },
    getNextDate(day) {
      const dd = new Date()
      dd.setDate(dd.getDate() + day)
      const y = dd.getFullYear()
      const m =
        dd.getMonth() + 1 < 10 ? '0' + (dd.getMonth() + 1) : dd.getMonth() + 1
      const d = dd.getDate() < 10 ? '0' + dd.getDate() : dd.getDate()
      return y + '-' + m + '-' + d
    },
    /**
     * @description 关闭对话框
     */
    handleClose() {
      this.$emit("on-close", false);
    },
    getHoursDatas(localeId, owner, date) {
      const param = {
        LocaleId: localeId,
        Owner: owner,
        AcquitDate: date
      };
      this.$post(
        "admin/queryLocaleData10MinExceedStandardTimesHourly",
        param
      ).then(res => {
        this.hourChartOption.xAxis.data = res.map(v => v.AcquitHour.substr(11))
        this.hourChartOption.series[0].data = res.map(v => v.ExceedStandardTimes)
      });
    },
    getMonthData(localeId, owner, begin, end) {
      const param = {
        LocaleId: localeId,
        Owner: owner,
        AcquitBeginDate: begin,
        AcquitEndDate: end
      };
      this.$post(
        "admin/queryLocaleData10MinExceedStandardTimesDaily",
        param
      ).then(res => {
        this.lineData.xAxis.data = res.map(v => {
          return v.AcquitDate;
        });
        this.lineData.series[0].data = res.map(v => {
          return v.ExceedStandardTimes;
        });
      });
    },
    dayChange() {
      this.getHoursDatas(this.localeId, this.owner, this.oneDay);
    },
    monthChange() {
      this.getMonthData(
        this.localeId,
        this.owner,
        this.peorid[0],
        this.peorid[1]
      );
    }
  }
};
</script>

<style lang="scss" scoped>
.checkbox_group_box {
  font-size: inherit;
  .el-checkbox {
    display: block;
  }
}
.notification_dialog_content {
  font-size: 13px;
  .el-form-item {
    margin-bottom: 0;
    .el-form-item__content {
      span {
        line-height: 40px;
      }
    }
  }
  h2 {
    text-align: center;
  }
  h4 {
    font-size: 14px;
    margin: 10px 0 5px;
  }

  h5 {
    font-size: 13px;
    margin: 5px 0;
  }

  p {
    margin: 5px 0;
  }

  .date_box {
    text-align: right;
    padding: 10px 0;
    margin-top: 20px;
    font-weight: bold;
    font-weight: 15px;
  }
}
</style>
<style>
.echarts {
  width: 100% !important;
}
</style>
